(function () {
  function initGridToggle(root) {
    var grid = root.querySelector('[data-zava-products]');
    var buttons = root.querySelectorAll('.zava-grid-toggle__btn');
    if (!grid || !buttons.length) return;

    var defaultCols = grid.getAttribute('data-default-cols') || '4';
    var saved = null;
    try {
      saved = localStorage.getItem('zava-grid-cols');
    } catch (e) {}
    var cols = saved || defaultCols;

    function applyCols(n) {
      grid.classList.remove('zava-products--2', 'zava-products--3', 'zava-products--4', 'zava-products--list');
      grid.classList.add('zava-products--' + n);
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-zava-cols') === String(n));
      });
      try {
        localStorage.setItem('zava-grid-cols', String(n));
      } catch (e) {}
    }

    applyCols(cols);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyCols(btn.getAttribute('data-zava-cols'));
      });
    });
  }

  function initFilterDrawer(root) {
    var openBtn = root.querySelector('[data-zava-filter-open]');
    var closeBtns = root.querySelectorAll('[data-zava-filter-close]');
    var overlay = root.querySelector('[data-zava-filter-overlay]');
    var drawer = root.querySelector('[data-zava-filter-drawer]');
    if (!openBtn || !drawer) return;

    function setOpen(isOpen) {
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      root.classList.toggle('is-filters-open', isOpen && !desktop);
      document.body.classList.toggle('zava-filters-locked', isOpen && !desktop);
      openBtn.setAttribute('aria-expanded', isOpen && !desktop ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', desktop || isOpen ? 'false' : 'true');
      if (overlay) {
        if (isOpen && !desktop) overlay.removeAttribute('hidden');
        else overlay.setAttribute('hidden', '');
      }
    }

    function syncDesktopA11y() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        setOpen(false);
        drawer.setAttribute('aria-hidden', 'false');
      } else if (!root.classList.contains('is-filters-open')) {
        drawer.setAttribute('aria-hidden', 'true');
      }
    }

    openBtn.addEventListener('click', function () {
      setOpen(true);
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setOpen(false);
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        setOpen(false);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-filters-open')) {
        setOpen(false);
      }
    });

    window.addEventListener('resize', syncDesktopA11y);
    syncDesktopA11y();
  }

  function boot() {
    document.querySelectorAll('[data-zava-collection]').forEach(function (root) {
      initGridToggle(root);
      initFilterDrawer(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
